export default __webpack_public_path__ + "static/media/hht2_ep03_timeline_10_blank.491f72f2.png";